import type React from 'react';

type Props = {
	url: string;
};

export const PromoImage: React.FC<Props> = ({ url }) => {
	return <img src={url} width={775} height={436} />;
};
